import { useSearchParams } from "react-router-dom";

const useCheckSource = () => {
    const [searchParams] = useSearchParams();
    const isCallCenterPortal = searchParams.get("formSource") === "callportal";

    return {
		isCallCenterPortal,
	};

}

export default useCheckSource;
